// TODO: Move this to a constants file outside of the component
export const BASE_TEST_ID = "sidenavbar-"

export const PAGE_MENU_PATHS = {
  Welcome: "/welcome",
  Messenger: "/messenger",
  PowerDialer: "/power-dialer",
  Stats: "/stats",
  LiveMonitor: "/live-monitor",
  EmailTemplatesLibrary: "/templates/email/library",
  EmailTemplatesComposer: "/templates/email/compose",
  SMSTemplatesLibrary: "/templates/sms/library",
  SMSTemplatesComposer: "/templates/sms/compose",
  CallScriptsLibrary: "/call/scripts",
  TemplatesLibrary: "/templates/library",
  ContactPropertiesLibrary: "/contact/properties/library",
  ContactListsLibrary: "/contact/lists/library",
  ContactBulkEditor: "/contact/bulk/editor",
  SequenceListsLibrary: "/sequences/library",
  ScheduledCalls: "/scheduled/calls",
  Settings: "/settings",
  DevTools: "/dev",
}
